/**
 * Lightweight internal product telemetry — allowlisted events only, fire-and-forget.
 */
import axios from 'axios';
import { getApiBase } from './apiBase';

const API = getApiBase();

export function trackProductEvent(eventName, options = {}) {
  if (!eventName) return;
  const payload = {
    event_name: eventName,
    archive_id: options.archiveId || undefined,
    person_id: options.personId || undefined,
    pillar: options.pillar || undefined,
    metadata: options.metadata || {},
  };
  axios.post(`${API}/events/product`, payload).catch(() => {
    // Never interrupt user flows for telemetry.
  });
}
